import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Text } from '@chakra-ui/react';
import React from 'react';
import is from 'is';
var _excluded = ["variant", "children"];
var Typography = function Typography(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? 'p' : _ref$variant,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */
  var textProps = _objectSpread2({}, rest);
  if (is.string(variant) && ['h0', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(variant)) {
    textProps.as = variant;
  }
  return /*#__PURE__*/React.createElement(Text, _extends({
    "data-object-type": "typography"
  }, textProps), children);
};
Typography.displayName = "Typography";
export { Typography };